import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { CustomerTabList } from "./CustomerTabList";
import { DoctorTabList } from "./DoctorTabList";
import { VendorTabList } from "./VendorTabList";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const ContactList: React.FC<any> = React.memo((props) => {
  const { control, setValue } = useForm<any>();
  const { tab } = useParams();
  const tabNum = Number(tab) || 0;
  const tabsData: any[] = [
    { label: "Doctor", content: <DoctorTabList /> },
    { label: "Customer", content: <CustomerTabList /> },
    { label: "Vendor", content: <VendorTabList /> },
  ];

  useEffect(() => {
    updateMainHeader("Contacts");
  });

  breadCrumbsStore.updateBreadCrumbs([{ "Contact List": "/contact/list" }]);

  return (
    <>
      <Grid container spacing={2} sx={{marginLeft:0}}>
        <WSTabs
          id="contacttabs"
          setValue={setValue}
          selectedTab={tabNum}
          control={control}
          name="tabs"
          tabs={tabsData}
          justifyTabs="flex-start"
        />
      </Grid>
    </>
  );
});
